import React, {Component} from 'react'
import {Line} from 'react-chartjs-2'
import * as PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import MuiTable from "../common/MuiTable";
import {NotificationManager} from "react-notifications";
import {organisationDetails, saveOrUpdateOrganisationDetails} from "../../util/ApiUtils";
import { t } from '../../i18n';
import * as CommonUtils from "../../util/CommonUtils";

const options = {
    scales: {
        yAxes: [{
            scaleLabel: {
                display: true,
                labelString: t('leadership.customerNumbers.chart.yLabel')
            },
            ticks: {
                min: 0
            }
        }],
        xAxes: [{
            scaleLabel: {
                display: true,
                labelString: t('leadership.customerNumbers.chart.xLabel')
            }
        }],
    }
}

function createChartData() {
    return {
        labels: [],
        datasets: [
            {
                label: t('leadership.customersNumbers'),
                fill: false,
                backgroundColor: '#1a73e8',
                borderColor: 'rgba(255,99,132,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                hoverBorderColor: 'rgba(255,99,132,1)',
                data: []
            }
        ]
    };
}

const muiColumns = [
    {
        title: t('context.common.id'),
        field: 'id',
        type: "numeric",
        hidden: true,
    },
    { title: t('leadership.customerNumbers.columns.year'), field: 'year'},
    { title: t('leadership.customerNumbers.columns.noOfCustomers'), field: 'noOfCustomers', headerStyle: { width: "50%" } },
];

class CustomerNumbers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            organisation: { customerNumbers: [] },
            orgId: null,
            customerNumbers: [],
            chartData: createChartData(),
            isLoading: true
        };
        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
        this.isValid = this.isValid.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log('organisation response', response);
                let organisation = response || {};
                let sorted = (organisation.customerNumbers || []).slice().sort(function(a, b) {
                    return a.year - b.year;
                });
                console.log('sorted customers', sorted);
                let chartData = createChartData();
                sorted.forEach((element) => {
                    chartData.labels.push(element.year)
                    chartData.datasets[0].data.push(element.noOfCustomers)
                })
                this.setState({
                    organisation: Object.assign({}, organisation, { customerNumbers: sorted }),
                    orgId: organisation.id,
                    customerNumbers: sorted,
                    chartData: chartData,
                    isLoading: false
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    isValid(newData) {
        let isValid = newData.year && newData.year !== '' && newData.noOfCustomers && newData.noOfCustomers !== '';
        if (!isValid) {
            NotificationManager.error(t('app.notifications.error'), t('messages.validationErrorFields'), 5000);
        }
        return isValid;
    }

    handleUpdate(toUpdate) {
        console.log("updating to ", toUpdate);
        for (let i = 0, l = this.state.organisation.customerNumbers.length; i < l; i++) {
            if (this.state.organisation.customerNumbers[i].id === toUpdate.id) {
                this.state.organisation.customerNumbers[i].year = toUpdate.year;
                this.state.organisation.customerNumbers[i].noOfCustomers = toUpdate.noOfCustomers;
            }
        }
        console.log("After update:", this.state.organisation.customerNumbers);
        this.handleSubmit(this.state.organisation.customerNumbers);
    }

    handleDelete(toDelete) {
        let customerNumbers = [];
        const index = this.state.organisation.customerNumbers.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.organisation.customerNumbers.length; i < l; i++) {
            if (i !== index) {
                customerNumbers.push(this.state.organisation.customerNumbers[i]);
            }
        }
        console.log("After removal:", customerNumbers);
        this.handleSubmit(customerNumbers);
    }

    handleAdd(data) {
        this.state.organisation.customerNumbers.push(data);
        this.handleSubmit(this.state.organisation.customerNumbers);
    }

    handleSubmit(data) {
        this.state.organisation.customerNumbers = data;
        saveOrUpdateOrganisationDetails(this.state.organisation)
            .then(() => {
                NotificationManager.success(t('app.notifications.success'), t('messages.dataUpdated'), 5000);
                this.loadOrganisationDetails();
                this.props.onChanged(this.state.organisation.customerNumbers);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    render() {
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        if (this.state.isLoading) {
            return null;
        }
        return (
            // A react-chart hyper-responsively and continuously fills the available
            // space of its parent element automatically
            <div>
                {this.props.isEdit ?
                    <React.Fragment>
                        <Paper style={{ marginTop: '30px' }}>
                            <MuiTable
                                title={ t('leadership.customersNumbers') }
                                columns={muiColumns}
                                data={this.state.customerNumbers}
                                onAdd={this.handleAdd}
                                onUpdate={this.handleUpdate}
                                onDelete={this.handleDelete}
                                isValid={this.isValid}
                                exportButton={false}
                                search={false}
                                pageSize={20}
                                headerStyle={{ background: "lightblue" }}
                                allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                            />
                        </Paper>
                    </React.Fragment>
                    :
                    <Line
                        data={this.state.chartData}
                        width={400}
                        height={300}
                        options={options}
                        redraw
                    />}
            </div>
        )};
}

CustomerNumbers.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    onChanged: PropTypes.func.isRequired,
}
export default CustomerNumbers;
